import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconArrowDown: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M7.406 8.578l4.594 4.594 4.594-4.594 1.406 1.406-6 6-6-6z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconArrowDown;
